



















































import { computed, defineComponent, ref, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';
import TagsContainer from '@/components/common/tags-container/index.vue';

const name = 'ttam-behavoir-hashtag-preoffline-hashtag-alert';
export default defineComponent({
  components: {
    TagsContainer,
  },
  props: {
    tags: {
      type: Array as PropType<Array<any>>,
      default: () => [],
    },
    hashtagBehaviorMap: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { tags } = toRefs(props);
    const closeTags = ref([]);
    const visibleTags = computed(() =>
      tags.value.filter(tag => {
        const set = new Set(closeTags.value.map(e => e.id));
        return !set.has(tag.id);
      }),
    );
    const dialogVisible = ref(false);

    const onRemoveAll = () => {
      emit('remove', tags.value);
      dialogVisible.value = false;
    };

    const onRemove = () => {
      emit('remove', closeTags.value);
      dialogVisible.value = false;
    };

    const onDialogClose = () => {
      closeTags.value = [];
    };
    return {
      name,
      dialogVisible,
      visibleTags,
      closeTags,
      onRemove,
      onRemoveAll,
      onDialogClose,
    };
  },
});
